import {Theme} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import React from "react";

const styles = (theme: Theme) => {
    return ({
        formsContainer: {
            marginTop: theme.spacing(2)
        },
        addBtn: {
            marginTop: theme.spacing(4)
        },
        actions: {
            '& > *': {
                marginLeft: theme.spacing(2)
            }
        },
        errorBanner: {
            width: '100%',
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText
        },
        errorOption: {}
    })
}

const withEditorComponentStyle = (WrappedComponent: React.FC<any>) => withStyles(styles)(WrappedComponent);
export default withEditorComponentStyle;
